module.exports = __webpack_public_path__ + "img/mobile-10.cbbfc9a3.png";